import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiContact\CreateWikiContactController::__invoke
* @see app/Http/Controllers/WikiContact/CreateWikiContactController.php
* @route '/api/wiki-contact'
*/
const CreateWikiContactController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiContactController.url(options),
    method: 'post',
})

CreateWikiContactController.definition = {
    methods: ["post"],
    url: '/api/wiki-contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiContact\CreateWikiContactController::__invoke
* @see app/Http/Controllers/WikiContact/CreateWikiContactController.php
* @route '/api/wiki-contact'
*/
CreateWikiContactController.url = (options?: RouteQueryOptions) => {
    return CreateWikiContactController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiContact\CreateWikiContactController::__invoke
* @see app/Http/Controllers/WikiContact/CreateWikiContactController.php
* @route '/api/wiki-contact'
*/
CreateWikiContactController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiContactController.url(options),
    method: 'post',
})

export default CreateWikiContactController